// Reveals elements in the hidden content of hooks showing one of their
// `content` targets at a time (tabs, menus), which the browser can't scroll to
// or focus on its own: switches to the content containing
// - the element the URL hash points to (e.g. a `#reviews` link), and scrolls
//   it into view
// - the first invalid field of a submitted form, and reports it there (the
//   browser otherwise gives up silently)
//
// Spread `reveal` into the hook, add `revealActions` to its `actions`, call
// `revealMounted()` / `revealDestroyed()` from its `mounted()` / `destroyed()`,
// and give it an `index` value of the shown content, switched by a `set_index`
// event pushed to itself. Nested hooks each switch their own content.

export const revealActions = [
  // `invalid` doesn't bubble
  { name: `revealInvalid`, type: `invalid`, capture: true },
]

export const reveal = {
  revealHashChangeHandler: null,
  revealInvalidShown: false,

  revealMounted() {
    this.revealHashChangeHandler = this.revealHashTarget.bind(this)
    window.addEventListener(`hashchange`, this.revealHashChangeHandler)
    this.revealHashTarget()
  },

  revealDestroyed() {
    window.removeEventListener(`hashchange`, this.revealHashChangeHandler)
  },

  revealInvalidAction(e) {
    // the browser reports the first of the fields invalid at once
    if (this.revealInvalidShown) return
    this.revealInvalidShown = true
    window.setTimeout(() => (this.revealInvalidShown = false))

    this.revealElement(e.target, () => e.target.reportValidity())
  },

  revealHashTarget() {
    const id = decodeURIComponent(window.location.hash.slice(1))
    const element = id && document.getElementById(id)
    if (!element) return

    this.revealElement(element, () => element.scrollIntoView())
  },

  // switches to the hidden content containing `element`, then calls `callback`
  // (the reply comes after the switched content is rendered)
  revealElement(element, callback) {
    const index = this.contentTargets.findIndex((content) =>
      content.contains(element)
    )
    if (index < 0 || index === this.indexValue) return

    this.pushEventToSelf(`set_index`, { index }, callback)
  },
}
